import { DialogContent, DialogContentText, Typography } from '@mui/material';
import React from 'react';
import ModalCustom from 'components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { closeDialogAction, closeDialogWithDataAction } from 'store/actions/dialogsActions';
import { useAppState } from 'store/Provider';
import { multipleWorkunitSaveAction, singleWorkunitSaveAction } from 'store/actions/changeBaselineActions';

const BaselineEditWorkunitCancelConfirmation = () => {
  const { state, dispatch } = useAppState();
  const { dialogs } = state;
  const isOpen = dialogs.BaselineEditWorkunitCancel;
  const { data, type } = dialogs?.data || {};

  const [t] = useTranslation();

  const confirmFn = async () => {
    if (type === 'single') {
      dispatch(singleWorkunitSaveAction(true));
    } else {
      dispatch(multipleWorkunitSaveAction(true));
    }
  };

  const closeFn = async () => {
    dispatch(closeDialogAction('BaselineEditWorkunitCancel'));
    dispatch(closeDialogWithDataAction({ name: 'changeBaselineeditworkunitDialog', data: { data, type } }));
  };

  const dialogBody = (
    <DialogContent>
      <DialogContentText>
        <Typography component="span">
          <strong>{t('Do you want to save the changes?')}</strong>
        </Typography>
        {/* <Typography>
          <br />
          <strong>{t('Note')}</strong> {t('Baseline_Cancel_Note')}
        </Typography> */}
      </DialogContentText>
    </DialogContent>
  );
  return (
    <ModalCustom
      open={isOpen}
      modalName="BaselineEditWorkunitCancel"
      onClose={() => closeFn()}
      onCloseEvent={() =>
        dispatch(closeDialogWithDataAction({ name: 'BaselineEditWorkunitCancel', data: { data, type } }))
      }
      onConfirm={() => confirmFn()}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: document.documentElement.clientWidth - 400, // Set your width here
          },
        },
      }}
      titleText="Confirmation"
      confirmText=" Yes "
      cancelText="No"
      body={dialogBody}
      size="md"
      confirmLoad
    />
  );
};

export default BaselineEditWorkunitCancelConfirmation;
